import { BaseModel, convertToArrayModels, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import DigitalLectureFilterOption from './DigitalLectureFilterOption'
import DigitalLectureFilterValue from './DigitalLectureFilterValue'

export default class DigitalLectureFilterGroup extends BaseModel {
  static override constructorName = 'DigitalLectureFilterGroup'

  options: DigitalLectureFilterOption[] = []
  values: DigitalLectureFilterValue[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.options = convertToArrayModels(data.options, DigitalLectureFilterOption)
      this.values = convertToArrayModels(data.values, DigitalLectureFilterValue)
    }
  }
}

registerModel(DigitalLectureFilterGroup)
